export default defineNuxtRouteMiddleware(async (to, _from) => {
    if (!to.query.token) {
        return navigateTo({ name: 'members-login-forgot' });
    }
});